module.exports = __webpack_public_path__ + "de0ee2daf5935b1cbb15378d4dfc70bd.svg";